<template>
  <div class="v-container">
    <div class="loadding-spin" v-if="loading">
      <Circle4></Circle4>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="title-body">
          <h3>DANH SÁCH ĐƠN HÀNG</h3>
          <div class="title-btn">
            <el-button @click="fn_tableShowFormSearch()" icon="el-icon-search"
              >ẩn/hiện tìm kiếm</el-button
            >
            <!-- <el-button
              type="primary"
              @click="fn_addAssess()"
              icon="el-icon-circle-plus-outline"
              >thêm mới đơn hàng</el-button
            > -->
          </div>
        </div>
        <div class="main-body">
          <el-form
            ref="myForm"
            label-width="110px"
            label-position="top"
            @submit.native.prevent
            :model="mData.tableRules.dataSearch.value"
          >
            <div
              :class="{
                'main-body-search': true,
                showFormSearch: mData.tableRules.showFormSearch,
              }"
            >
              <b-collapse
                v-bind:visible="mData.tableRules.showFormSearch"
                id="myFormSearch"
                class="b-shadow"
              >
                <b-card style="min-height: auto">
                  <b-row>
                    <b-col md="3">
                      <el-form-item label="Mã đơn hàng" prop="">
                        <el-input
                          size="medium"
                          v-model="
                            mData.tableRules.dataSearch.value.ma_don_hang
                          "
                          clearable
                          @change="
                            () => {
                              mData.tableRules.dataSearch.value.ma_don_hang =
                                mData.tableRules.dataSearch.value.ma_don_hang.trim();
                            }
                          "
                        />
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item label="Tỉnh" prop="">
                        <el-select
                          size="medium"
                          v-model="mData.tableRules.dataSearch.value.tinh_id"
                          placeholder="Chọn tỉnh"
                          clearable
                          filterable
                        >
                          <el-option
                            v-for="item in provinceLists"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item label="Đại lý" prop="">
                        <el-select
                          size="medium"
                          v-model="mData.tableRules.dataSearch.value.dai_ly_id"
                          placeholder="Chọn đại lý"
                          clearable
                          filterable
                        >
                          <el-option
                            v-for="item in daiLyLists"
                            :key="item.id"
                            :label="item.ten"
                            :value="item.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item label="Tên dòng họ" prop="">
                        <el-input
                          size="medium"
                          v-model="
                            mData.tableRules.dataSearch.value[
                              'dong_ho.ten_dong_ho'
                            ]
                          "
                          clearable
                          @change="
                            () => {
                              mData.tableRules.dataSearch.value[
                                'dong_ho.ten_dong_ho'
                              ] =
                                mData.tableRules.dataSearch.value[
                                  'dong_ho.ten_dong_ho'
                                ].trim();
                            }
                          "
                        />
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item label="Sản phẩm">
                        <el-select
                          v-model="
                            mData.tableRules.dataSearch.value[
                              'danh_sach_san_pham.san_pham_id'
                            ]
                          "
                          placeholder="Chọn"
                          size="medium"
                          clearable
                        >
                          <el-option
                            v-for="(item, index) in prdSanPhamLists"
                            :key="index"
                            :label="item.ten_san_pham"
                            :value="item.san_pham_id"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item label="Ngày tạo từ" prop="">
                        <el-date-picker
                          size="medium"
                          v-model="thoiDiemTaoTu"
                          style="width: 100%"
                          type="date"
                          placeholder="Chọn ngày"
                          format="dd/MM/yyyy"
                        />
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item label="Ngày tạo đến" prop="">
                        <el-date-picker
                          size="medium"
                          v-model="thoiDiemTaoDen"
                          style="width: 100%"
                          type="date"
                          placeholder="Chọn ngày"
                          format="dd/MM/yyyy"
                        />
                      </el-form-item>
                    </b-col>
                  </b-row>
                  <el-form-item class="text-center mb-0">
                    <el-button
                      icon="el-icon-search"
                      type="primary"
                      native-type="submit"
                      v-ladda
                      @click="fn_tableSearch()"
                      >Tìm kiếm</el-button
                    >
                  </el-form-item>
                </b-card>
              </b-collapse>
            </div>
            <b-row class="mb-3">
              <b-col md="3">
                <el-select
                  size="medium"
                  v-model="mData.tableRules.dataSearch.value.trang_thai"
                  clearable
                  placeholder="Chọn trạng thái đơn hàng"
                  @change="fn_tableSearch"
                >
                  <el-option
                    v-for="item in orderStatusList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </b-col>
            </b-row>
          </el-form>
          <div class="main-body-table">
            <el-table
              stripe
              :data="mData.tableRules.data"
              border
              :max-height="heightTable"
              style="width: 100%"
              @sort-change="fn_tableSortChange"
              :default-sort="{
                prop: mData.tableRules.defaultSort[0],
                order: mData.tableRules.defaultSort[1],
              }"
              v-loading="loadingTable"
            >
              <el-table-column prop="" label="STT" width="50" fixed>
                <template slot-scope="scope">
                  <div class="text-center">
                    {{ mData.tableRules.offset + scope.$index + 1 }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="ma_don_hang"
                label="Mã đơn hàng"
                width="130"
                align="center"
                :sortable="mData.tableRules.allowSorting"
              >
                <template slot-scope="scope">
                  <router-link
                    :to="`/admin/don-hang/danh-sach-don-hang/chi-tiet/${scope.row.id}`"
                  >
                    <span class="router-link--css">{{
                      scope.row.ma_don_hang
                    }}</span>
                  </router-link>
                </template>
              </el-table-column>
              <el-table-column label="Tỉnh" width="150" align="center">
                <template slot-scope="scope">
                  {{ getNameDaiLyTinh(scope.row.dai_ly_tinh_id) }}
                </template>
              </el-table-column>
              <el-table-column label="Đại lý" width="150" align="center">
                <template slot-scope="scope">
                  <router-link
                    :to="`/admin/dai-ly/chi-tiet/${scope.row.dai_ly_id}`"
                    target="_blank"
                  >
                    <span class="router-link--css">{{
                      getNameDaiLy(scope.row.dai_ly_id)
                    }}</span>
                  </router-link>
                </template>
              </el-table-column>
              <el-table-column
                prop="ten_san_pham"
                label="Tên sản phẩm"
                min-width="200"
              ></el-table-column>
              <el-table-column
                prop="dong_ho.ten_dong_ho"
                label="Dòng họ"
                min-width="130"
                :sortable="mData.tableRules.allowSorting"
              ></el-table-column>
              <el-table-column
                prop="thoi_diem_tao"
                label="Ngày tạo đơn"
                align="center"
                width="160"
                :sortable="mData.tableRules.allowSorting"
              >
                <template slot-scope="scope">
                  {{
                    MethodService.formatDate(
                      scope.row.thoi_diem_tao,
                      "datetime"
                    )
                  }}
                </template>
              </el-table-column>
              <el-table-column
                prop="thanh_tien"
                label="Tổng tiền"
                width="140"
                align="right"
                :sortable="mData.tableRules.allowSorting"
              >
                <template #default="scope">
                  {{ MethodService.formatCurrencyVND(scope.row.thanh_tien) }}
                </template>
              </el-table-column>
              <el-table-column
                prop="trang_thai"
                label="Trạng thái"
                align="center"
                width="185"
                :sortable="mData.tableRules.allowSorting"
              >
                <template slot-scope="scope">
                  <p class="trang-thai_don-hang">
                    <el-tag
                      size="large"
                      :class="{
                        'wait-for-pay':
                          scope.row.trang_thai == 'cho_thanh_toan',
                        paid: scope.row.trang_thai == 'da_thanh_toan',
                        cancel: scope.row.trang_thai == 'huy',
                        'in-process': scope.row.trang_thai == 'dang_xu_ly',
                        'to-return': scope.row.trang_thai == 'hoan_tra',
                        complete: scope.row.trang_thai == 'hoan_thanh',
                      }"
                    >
                      {{
                        scope.row.trang_thai == "cho_thanh_toan"
                          ? "Chờ thanh toán"
                          : scope.row.trang_thai == "da_thanh_toan"
                          ? "Đã thanh toán"
                          : scope.row.trang_thai == "huy"
                          ? "Hủy"
                          : scope.row.trang_thai == "dang_xu_ly"
                          ? "Đang xử lý"
                          : scope.row.trang_thai == "hoan_tra"
                          ? "Hoàn trả"
                          : scope.row.trang_thai == "hoan_thanh"
                          ? "Hoàn thành"
                          : ""
                      }}
                    </el-tag>
                    <span
                      :class="{
                        paid:
                          scope.row.trang_thai_thanh_toan == 'da_thanh_toan',
                      }"
                    >
                      <i class="fa-solid fa-coins"></i>
                    </span>
                  </p>
                </template>
              </el-table-column>
              <el-table-column
                label="Thao tác"
                align="center"
                width="80px"
                fixed="right"
              >
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    plain
                    @click="fn_handle('detail', scope.$index, scope.row)"
                    v-b-popover.hover.left="aLang.c_detail"
                  >
                    <i class="fa fa-eye"></i>
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="mt-2 text-right" v-if="mData.tableRules.allowPaging">
              <el-pagination
                @size-change="fn_tableSizeChange"
                :page-sizes="mData.tableRules.lengthMenu"
                :page-size="mData.tableRules.limit"
                :current-page="mData.tableRules.page"
                @current-change="fn_tableCurentChange"
                @prev-click="fn_tablePrevClick"
                @next-click="fn_tableNextClick"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="mData.tableRules.total"
                :pager-count="5"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Circle4 } from "vue-loading-spinner";
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import DataForm from "../../../dataForm/dataFormDonHang";
import mushroom from "viettoc-api";

export default {
  data() {
    return {
      MethodService,
      data: undefined,
      thoiDiemTaoTu: undefined,
      thoiDiemTaoDen: undefined,
      aLang: LanguageService.lang,
      loading: true,
      loadingTable: false,
      heightTable: 550,
      mData: {
        tableRules: MethodService.copyObject(DataForm.tableRules),
      },
      loaiDonHang: [
        {
          value: "khoi_tao",
          label: "Khởi tạo",
        },
        {
          value: "gia_han",
          label: "Gia hạn",
        },
      ],
      provinceLists: [],
      daiLyTinhLists: [],
      daiLyLists: [],
      prdSanPhamLists: [],
      orderStatusList: [
        {
          value: "cho_thanh_toan",
          label: "Chờ thanh toán",
        },
        {
          value: "da_thanh_toan",
          label: "Đã thanh toán",
        },
        {
          value: "dang_xu_ly",
          label: "Đang xử lý",
        },
        {
          value: "hoan_thanh",
          label: "Hoàn thành",
        },
        {
          value: "huy",
          label: "Hủy",
        },
        {
          value: "hoan_tra",
          label: "Hoàn trả",
        },
      ],
    };
  },
  components: {
    Circle4,
  },
  methods: {
    async fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
        const thoiDiemTaoTuFilter = this.mData.tableRules.filters.match(
          /&thoi_diem_tao>=[^&]+/g
        );
        const thoiDiemTaoDenFilter = this.mData.tableRules.filters.match(
          /&thoi_diem_tao<=[^&]+/g
        );
        if (thoiDiemTaoTuFilter) {
          this.thoiDiemTaoTu = new Date(
            decodeURIComponent(thoiDiemTaoTuFilter[0].split(">=")[1])
          );
        }
        if (thoiDiemTaoDenFilter) {
          this.thoiDiemTaoDen = new Date(
            decodeURIComponent(thoiDiemTaoDenFilter[0].split("<=")[1])
          );
        }
        delete this.mData.tableRules.dataSearch.value.thoi_diem_tao;
      }
      if (this.$route.query.showFormSearch) {
        if (this.$route.query.showFormSearch == "true") {
          this.mData.tableRules.showFormSearch = true;
          this.heightTable = window.innerHeight - 390;
        } else {
          this.mData.tableRules.showFormSearch = false;
          this.heightTable = window.innerHeight - 300;
        }
      }
    },
    async initDataDefault() {
      try {
        const daiLyTinhRes = await mushroom.agt_dai_ly_tinh.listAsync({
          limit: 100000,
        });
        const provinceRes = await mushroom.province.listAsync();
        const daiLyRes = await mushroom.agt_dai_ly.listAsync({
          fields: "id, ten",
          limit: 100000,
        });
        const sanPhamRes =
          await mushroom.ord_don_hang.views.danh_sach_san_phamAsync();
        console.log("sanPhamRes", sanPhamRes);
        daiLyTinhRes.result.forEach((daiLy) => {
          const province = provinceRes.result.find(
            (x) => x.id === daiLy.tinh_id
          );
          daiLy.dai_ly_tinh_name = `${province.name}`;
        });
        this.provinceLists = provinceRes.result;
        this.daiLyTinhLists = daiLyTinhRes.result;
        this.daiLyLists = daiLyRes.result;
        this.prdSanPhamLists = sanPhamRes.result;
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },
    async fn_initTable() {
      let dataFilter = {
        filters: this.mData.tableRules.filters,
      };
      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }
      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name: "DanhSachDonHang",
            query: {
              limit: this.mData.tableRules.limit,
              page: this.mData.tableRules.page,
              sort: this.mData.tableRules.sort,
              filters: this.mData.tableRules.filters,
              showFormSearch: this.mData.tableRules.showFormSearch,
            },
          })
          .catch((err) => {});
      }
      try {
        const response = await mushroom.ord_don_hang.listAsync(dataFilter);
        console.log("11111", response.result);
        if (response.result) {
          this.loading = false;

          this.mData.tableRules.data = await this.fn_changeData(
            response.result
          );
          this.mData.tableRules.total = response.meta.total;
          this.mData.tableRules.page =
            response.meta.offset / response.meta.limit + 1;
          setTimeout(() => {
            this.loadingTable = false;
          }, 300);
        }
      } catch (e) {
        console.log(e.code);
        if (e.code === 4) {
          this.loading = false;
          window.toastr.error(this.aLang.no_server);
        } else if (e.code === 2) {
          this.loading = false;
          window.toastr.error("Máy chủ không phản hồi");
          console.log(e);
        }
        this.loadingTable = false;
      }
    },
    fn_tableSortChange(column) {
      this.loadingTable = true;
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    fn_changeData(data) {
      data.forEach((element) => {
        // element.thoi_diem_tao = MethodService.formatDate(
        //   element.thoi_diem_tao,
        //   "datetime"
        // );
        const arrTenSanPham = MethodService.findListItemDifferent(
          element.danh_sach_san_pham,
          "ten_san_pham"
        );
        element.ten_san_pham =
          arrTenSanPham.length > 0 ? arrTenSanPham.join(", ") : "";
      });
      return data;
    },

    // phân trang
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.mData.tableRules.page = 1;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },

    // xem chi tiết, xóa bảng
    fn_handle(type, scope, row) {
      if (type == "detail") {
        this.$router.push({
          name: "ChiTietDonHang",
          params: { id: row.id },
        });
      }
      if (type == "update") {
        this.$router.push({
          name: "CapNhatDonHang",
          params: { id: row.id },
        });
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning",
        })
          .then(() => {
            this.fn_delete(row.id);
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },
    async fn_delete(id) {
      // try {
      //   await mushroom.ldp_danh_gia.deleteAsync({ id: id });
      //   this.$store.commit("fn_countDanhGia", "tru");
      // } catch (e) {
      //   console.log(e.code);
      //   if (e.code === 4) {
      //     window.toastr.error(this.aLang.no_server);
      //   } else if (e.code === 2) {
      //     window.toastr.error("Máy chủ không phản hồi");
      //     console.log(e);
      //   } else {
      //     window.toastr.error("Đã có lỗi xảy ra. Hãy thử lại");
      //   }
      // }
      // this.fn_initTable();
    },

    // tìm kiếm
    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch =
        !this.mData.tableRules.showFormSearch;
      if (this.mData.tableRules.showFormSearch) {
        this.heightTable = window.innerHeight - 390;
      } else {
        setTimeout(() => {
          this.heightTable = window.innerHeight - 300;
        }, 300);
      }
      this.$router.replace({
        name: "DanhSachDonHang",
        query: {
          limit: this.mData.tableRules.limit,
          page: this.mData.tableRules.page,
          sort: this.mData.tableRules.sort,
          filters: this.mData.tableRules.filters,
          showFormSearch: this.mData.tableRules.showFormSearch,
        },
      });
      this.fn_initTable(this.mData.tableRules.filters);
    },
    fn_tableSearch() {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          this.loading = true;
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          if (this.thoiDiemTaoTu) {
            this.mData.tableRules.filters += `&thoi_diem_tao>=${MethodService.toIsoDate(
              this.thoiDiemTaoTu
            )}`;
          }
          if (this.thoiDiemTaoDen) {
            const date23h = new Date(
              new Date(this.thoiDiemTaoDen).setHours(23, 59, 59)
            ).toISOString();
            this.mData.tableRules.filters += `&thoi_diem_tao<=${encodeURIComponent(
              MethodService.toIsoDate(date23h)
            )}`;
          }
          this.mData.tableRules.offset = 0;
          this.fn_initTable();
          MethodService.stopLadda();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    forceUpdateUI() {
      this.$forceUpdate();
    },
    fn_addAssess() {
      this.$router.push({
        name: "ThemDonHang",
      });
    },
    getNameDaiLyTinh(daiLyTinhId) {
      const daiLyTinh = this.daiLyTinhLists.find((e) => e.id === daiLyTinhId);
      return daiLyTinh && daiLyTinh.dai_ly_tinh_name
        ? daiLyTinh.dai_ly_tinh_name
        : daiLyTinhId;
    },
    getNameDaiLy(daiLyId) {
      const daiLy = this.daiLyLists.find((e) => e.id === daiLyId);
      return daiLy && daiLy.ten ? daiLy.ten : "";
    },
    formatCurrency(value) {
      return;
    },
  },
  //run after render view
  async created() {
    this.fn_hashUrl();
    await this.initDataDefault();
    await this.fn_initTable();
  },
  async mounted() {},
};
</script>
<style lang="scss" scoped>
.main-body-search {
  &.showFormSearch {
    margin-bottom: 20px;
  }
}
.card {
  min-height: 88vh;
}
.card-header {
  background-color: #fafafa;
  border: 1px solid rgba(26, 54, 126, 0.125);
  border-bottom: none;
  text-align: center;
}
.title-body {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
}
.title-btn {
  margin-top: 10px;
}
.text-box {
  display: flex;
  justify-content: center;
}

.el-tag {
  min-height: 32px;
  width: 130px;
  &__content {
    font-size: 14px;
    font-weight: 400 !important;
  }
  &.wait-for-pay {
    background-color: #d9e5ff;
    color: #000000;
  }
  &.paid {
    background-color: #c6c7f8;
    color: #000000;
  }
  &.cancel {
    background-color: #ff4747;
    color: #ffffff;
  }
  &.in-process {
    background-color: #ffe999;
    color: #000000;
  }
  &.to-return {
    background-color: #e8e8e8;
    color: #000000;
  }
  &.complete {
    background-color: #7ddd96;
    color: #ffffff;
  }
}
.trang-thai_don-hang {
  .fa-coins {
    font-size: 22px;
    color: #bdbdbd;
    margin-left: 10px;
  }
  .paid {
    .fa-coins {
      color: #fec800;
    }
  }
}
.router-link--css {
  color: #606266;
  &:hover {
    color: #20a8d8;
    cursor: pointer;
    text-decoration: underline;
  }
}
a:hover {
  text-decoration: none;
}

@media (min-width: 960px) {
  .title-body {
    flex-direction: row;
  }
}
</style>
